/**
 * Default WMS version.
 * @type {string}
 */
export const DEFAULT_WMS_VERSION = '1.3.0';
